import AuthService from "./AuthService"
import UserService from "./UserService"
import RailAppService from "./RailAppService"

const createAuthService = () => {
  return AuthService
}

const createUserService = () => {
  return UserService
}

const createRailAppService = () => {
  return RailAppService
}

export {
  createAuthService,
  createUserService,
  createRailAppService
}
